import { axiosInstance } from "../axios-instance";

const couponsServices = {
  getCoupons: () => axiosInstance.get(`/coupons`),
  getCoupon: (id) => axiosInstance.get(`/coupons/${id}`),
  storeCoupon: (payload) => axiosInstance.post(`/coupons`, payload),
  updateCoupon: (payload) =>
    axiosInstance.put(`/coupons/${payload.id}`, payload),
  deleteCoupon: (id) => axiosInstance.delete(`/coupons/${id}`),
  filterCoupons: (payload) => axiosInstance.post(`/coupons/filter`, payload),
};

export default couponsServices;
